import SectionHeader from "../SectionHeader";
import Reveal from "../Reveal";
import { FAQS, slug } from "../../data/site";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "../ui/accordion";

export const Faq = () => (
  <section id="faq" data-testid="faq-section" className="bg-[#111] section-pad scroll-mt-16">
    <div className="container-x">
      <SectionHeader eyebrow="FAQ" eyebrowTestId="faq-eyebrow" title="Before you ask." />
      <Reveal className="max-w-2xl mx-auto">
        <Accordion type="single" collapsible defaultValue="item-0" data-testid="faq-accordion">
          {FAQS.map((f, i) => (
            <AccordionItem key={i} value={`item-${i}`} className="border-white/10">
              <AccordionTrigger
                data-testid={`faq-trigger-${slug(f.q)}`}
                className="font-heading text-sm md:text-base font-bold text-white hover:text-[#C8F031] hover:no-underline py-5 text-left min-h-[44px]"
              >
                {f.q}
              </AccordionTrigger>
              <AccordionContent
                data-testid={`faq-content-${slug(f.q)}`}
                className="text-sm text-white/50 leading-relaxed"
              >
                {f.a}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </Reveal>
    </div>
  </section>
);

export default Faq;
